import comp from "./ScreenPanel";
export default comp;
